// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"f3d146b4","425":"08db555c","510":"f90c45da","532":"414d80e7","633":"224777f3","634":"1af707db","922":"dbcde0c0","937":"888115b7","972":"dc9c520e"}[chunkId] + ".chunk.js";
};